<template>
  <div class="wrapper page-klk-container dkt">
    <div class="container">
      <Banner desc="“有智有趣，爱看爱学”——由湖南省教育厅组织实施、芒果TV联合推出的在线知识教育品牌“智趣新课堂”，致力打造集知识性与趣味性于一体的新型教学资源。通过学习型动漫形象“芒果果、莓朵朵”的剧情演绎和趣味互动，让学生在寓教于乐中完成知识的获取、吸收及运用，让知识学习更有效、更轻松。
应用场景一：落实中央“双减”政策，做强做优免费线上学习服务；应用场景二：促进教育均衡，为农村学校提供新型网络联校资源。" :bannerInfo="bannerInfo" @play="onPlayClick"></Banner>
      <Character v-if="characterList.length" :character-list="characterList"></Character>
      <Topic :page-name="'dkt'" :topic-list="topicList" @play="onPlayClick"></Topic>
    </div>
    <div class="footer-bg"></div>
  </div>
</template>
<script>
import Banner from '@/components/banner.vue'
import Character from '@/components/character.vue'
import Topic from '@/components/topic'
import axios from '@/utils/request'
import jumpPage from '@/utils/utils'

export default {
  components: {
    Banner,
    Character,
    Topic
  },
  data () {
    return {
      // vclassId: (false ? [1431903, 1639482, 1639542, 1639546, 1639547] : [742907]),
      vclassId: (process.env.NODE_ENV === 'production' ? [1431903, 1639482, 1639542, 1639546, 1639547] : [742907]),
      bannerInfo: {
        videoList: []
      },
      characterList: [],
      topicList: []
    }
  },
  mounted () {
    this.getData(this.vclassId[0], 0)
    document.body.setAttribute('mg-stat-page', 'klk_newClass')
    window.MgStat.send('pv', {}, {src: 'klk'}) // 手动发送PV
  },
  methods: {
    getData (id, index) {
      axios.get(`${this.serverUrl}/home/cms/list?vclassId=${id}`).then(res => {
        const moduleData = res.data.moduleList
        let topicList = [...this.topicList]
        moduleData.map(item => {
          if (item.ottModuleType === 'web_banner') {
            this.bannerInfo.videoList = item.videoList
          } else if (item.ottModuleType === 'character_module') {
            this.characterList = item.videoList
          } else if (item.ottModuleType === 'topic_module') {
            topicList.push({videoList: item.videoList, moduleTitle: item.moduleTitle, caseId: item.caseId})
          }
        })
        this.topicList = topicList
        index++
        if (index < this.vclassId.length) {
          this.getData(this.vclassId[index], index)
        }
      })
    },
    onPlayClick: function (vi) {
      let url = jumpPage(vi)
      window.open(`${this.videoPlayUrl}${url}`, '_blank')
      // const vid = vi.jumpDefaultParam[0].value
      // // modal.player && modal.player.fetchVideoInfo(vid);
      // // modal.qrCode = getKlkUrl(video);
      // // jumpID是3605就是学习计划，3602是单视频
      // const isPlan = vi.jumpId == 3605
      // window.open(window.location.origin + window.location.pathname + `#/video?type=${isPlan?'plan':'video'}&id=${vid}&cxid=${isPlan?'1s6lhj7va':'2fvxf8uus'}`, '_blank');
    }
  }
}
</script>
<style scoped>
  .page-klk-container {
    background-image: url("./images/dkt-top.jpg");
    background-repeat: no-repeat;
    background-color: #A2D1E5;
  }
  .footer-bg {
    background: url("./images/dkt-bottom.jpg")no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/pages/dkt.vue